module.exports = __webpack_public_path__ + "media/images/video-off-0ee9403dac79fb35cb58816240b6aea5.svg";